import { Button } from "@/components/ui/button";
import { NAV } from "@/constants/testIds";
import { Link } from "react-router-dom";
import { Truck } from "lucide-react";

export default function SiteHeader({ onDonate }) {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-slate-950/80 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-4 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group">
          <div className="w-9 h-9 bg-kinetic flex items-center justify-center rotate-[-6deg] group-hover:rotate-0 transition-transform">
            <Truck className="w-5 h-5 text-black" strokeWidth={2.5} />
          </div>
          <div className="font-display font-black text-lg tracking-tight">
            RALLY<span className="text-kinetic">.</span>
          </div>
          <span className="hidden sm:inline font-mono text-[10px] uppercase tracking-widest text-slate-500 border-l border-white/10 pl-3 ml-1">
            Courier // Logistics
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-7 font-mono text-xs uppercase tracking-widest text-slate-400">
          <a data-testid={NAV.story} href="#story" className="hover:text-white transition-colors">Story</a>
          <a data-testid={NAV.progress} href="#progress" className="hover:text-white transition-colors">Progress</a>
          <a data-testid={NAV.tiers} href="#tiers" className="hover:text-white transition-colors">Tiers</a>
          <a data-testid={NAV.wall} href="#wall" className="hover:text-white transition-colors">Wall</a>
          <Link data-testid={NAV.admin} to="/admin" className="hover:text-white transition-colors">Admin</Link>
        </nav>
        <Button
          data-testid={NAV.backBtn}
          onClick={onDonate}
          className="bg-kinetic hover:bg-[#FF5E1A] text-black font-bold uppercase tracking-wide rounded-none px-5"
        >
          Back The Fleet
        </Button>
      </div>
    </header>
  );
}
